module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-600.woff2?43a1f1adcd9f2a20cf7a0f00ca0d2caf";